import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tp_cart') || '[]'); } catch { return []; }
  });
  const [restaurant, setRestaurant] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tp_cart_rest') || 'null'); } catch { return null; }
  });

  useEffect(() => {
    localStorage.setItem('tp_cart', JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem('tp_cart_rest', JSON.stringify(restaurant));
  }, [restaurant]);

  const addItem = (rest, item) => {
    if (restaurant && restaurant.id !== rest.id) {
      if (!window.confirm('Your cart has items from another restaurant. Replace?')) return;
      setItems([{ ...item, qty: 1 }]);
      setRestaurant(rest);
      return;
    }
    setRestaurant(rest);
    setItems(prev => {
      const ex = prev.find(p => p.id === item.id);
      if (ex) return prev.map(p => p.id === item.id ? { ...p, qty: p.qty + 1 } : p);
      return [...prev, { ...item, qty: 1 }];
    });
  };

  const removeItem = (id) => setItems(prev => {
    const ex = prev.find(p => p.id === id);
    if (!ex) return prev;
    if (ex.qty === 1) return prev.filter(p => p.id !== id);
    return prev.map(p => p.id === id ? { ...p, qty: p.qty - 1 } : p);
  });

  const clear = () => { setItems([]); setRestaurant(null); };

  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, restaurant, addItem, removeItem, clear, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
